<div class="modal-content">
  <div class="modal-header align-items-center">
    <div class="d-flex flex-column">
      <h2 class="modal-title mb-1">{{ 'manageEvent.editContact.title' | translate }}</h2>
      <p class="text-muted small mb-0">{{ 'manageEvent.editContact.requiredHint' | translate }}</p>
    </div>
    <i class="fa-solid fa-xmark fs-2 cursor-pointer" (click)="close()"></i>
  </div>

  <div class="modal-body">
    <div class="row">
      <h3>{{ 'manageEvent.editContact.contactInfo' | translate }}</h3>
    </div>

    <div class="row spacing-15">
      <div class="col-md-6">
        <app-input-component
          [label]="('manageEvent.editContact.firstName' | translate) + ' *'"
          [type]="'text'"
          [placeholder]="'manageEvent.editContact.firstNamePlaceholder' | translate"
          [(value)]="first_name"
          [invalid]="isFirstNameInvalid"
        />
      </div>
      <div class="col-md-6">
        <app-input-component
          [label]="('manageEvent.editContact.lastName' | translate) + ' *'"
          [type]="'text'"
          [placeholder]="'manageEvent.editContact.lastNamePlaceholder' | translate"
          [(value)]="last_name"
          [invalid]="isLastNameInvalid"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-md-6">
        <app-input-component
          [label]="'manageEvent.editContact.email' | translate"
          [type]="'email'"
          [placeholder]="'manageEvent.editContact.emailPlaceholder' | translate"
          [(value)]="email"
        />
      </div>
      <div class="col-md-6">
        <app-input-component
          [label]="'manageEvent.editContact.phone' | translate"
          [type]="'tel'"
          [placeholder]="'manageEvent.editContact.phonePlaceholder' | translate"
          [(value)]="phone"
        />
      </div>
    </div>

    <div class="row spacing-15">
      <div class="col-12">
        <label class="form-label">{{ 'manageEvent.editContact.role' | translate }} <span class="text-danger">*</span></label>
        <app-selectorini
          [placeholder]="'manageEvent.editContact.rolePlaceholder' | translate"
          [options]="roles"
          [disabled]="loadingRoles"
          [valueKey]="'role_id'"
          [displayKey]="'role_name'"
          [(value)]="role_id"
          [invalid]="isRoleInvalid"
        />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-12 d-flex justify-content-end">
        <app-button
          [variant]="'primary'"
          [label]="saving ? ('common.saving' | translate) : ('manageEvent.editContact.updateContact' | translate)"
          [iconClass]="saving ? 'fa fa-spinner fa-spin' : 'fa fa-save'"
          [disabled]="saving"
          (clicked)="onSave()"
        />
      </div>
    </div>
  </div>
</div>
